<!--
* @Name：询比价项目发布审批
* @Author: 王超
* @Date: 2025-10-13 10:39:49
* @Last Modified by: 王超
* @Last Modified time: 2025-10-13 10:39:49
-->
<template>
  <div class="approval-container">
    <van-nav-bar title="询比价发布审批" left-arrow left-text="返回" @click-left="onClickLeft" :fixed="true" />
    <van-collapse class="approval-info" v-model="activeNames">
      <van-collapse-item name="baseInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">询价说明</span>
        </template>
        <base-info :head-info="headInfo" />
      </van-collapse-item>
      <van-collapse-item name="bidInfo">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">标的</span>
        </template>
        <bid-info
          :bid-list="headInfo.pmPriceCompSubjectList"
          :pc-type="headInfo.pcType"
          :tiered-price="headInfo.tieredPrice"
        />
      </van-collapse-item>
      <van-collapse-item name="bidSuppInfo">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">投标单位</span>
        </template>
        <bid-supp-list :supp-info-list="suppInfo" />
      </van-collapse-item>
      <van-collapse-item name="noticeContent">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">报价须知</span>
        </template>
        <hi-card>
          <van-row v-html="notice.noticeContent" />
        </hi-card>
      </van-collapse-item>
      <van-collapse-item name="bidDocInfo">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">招标文件</span>
        </template>
        <bid-doc-info :bid-list="docList" />
      </van-collapse-item>
      <van-collapse-item name="bidJudgeList">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">评定人员选择</span>
        </template>
        <bid-judge-list :supp-info-list="judgePersion" />
      </van-collapse-item>
      <van-collapse-item name="approvalOpinions">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">审批意见</span>
        </template>
        <hi-flow-approval />
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import {
  searchSubjectInfo,
  searchPriceCompSupp,
  selectPriceCompNoticeById,
  selectPriceCompDocList,
  getJudgePersion
} from '@/api/pmPriceCompApproval'
import Bridge from '@/components/dsbridge'
export default {
  name: 'PmPriceCompApproval',
  components: {
    'base-info': () => import('./components/BaseInfo.vue'),
    'bid-info': () => import('./components/BidInfo'),
    'bid-supp-list': () => import('./components/BidSuppList.vue'),
    'bid-doc-info': () => import('./components/BidDocInfo.vue'),
    'bid-judge-list': () => import('./components/BidJudgeList.vue')
  },
  data() {
    return {
      activeNames: ['baseInfo', 'approvalOpinions'],
      headInfo: {},
      // 供应商信息
      suppInfo: [],
      notice: {},
      docList: [],
      judgePersion: [],
      attachList: [],
      businessKey: this.$route.query.businessKey
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    async initData() {
      const compInfoResp = await searchSubjectInfo({ pcInfoId: this.businessKey })
      this.headInfo = compInfoResp.data
      const suppInfoResp = await searchPriceCompSupp({ pcInfoId: this.businessKey })
      this.suppInfo = suppInfoResp.data.pmPriceCompSuppDtoList
      const noticeResp = await selectPriceCompNoticeById({ pcInfoId: this.businessKey })
      this.notice = noticeResp.data
      const docListResp = await selectPriceCompDocList(this.businessKey)
      this.docList = docListResp.data
      const judgePersionResp = await getJudgePersion(this.businessKey)
      this.judgePersion = judgePersionResp.data
    },
    onClickLeft() {
      Bridge.callMethodSyn('app.jsLeavePage', '')
    }
  }
}
</script>
<style lang="scss" scoped>
.title-class {
  background-color: #eee;
}
</style>
